import Colors from '@/v2/constants/Colors';

export const studentTopbarHeight = '80px';

export const studentPagePadding = '56px';

export const studentShadow = `0px 4px 16px #5E748A${Colors.HEX_OPACITIES[10]}`;
